import React, { useEffect, useState } from 'react'
import Layouts from '../layouts/Layouts'
import { TableView } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getOtherIncome } from '../../models/other_income/other_income_m'

import Paginate from '../pagination/Paginate'
import Moment from 'react-moment'

import { NumericFormat } from 'react-number-format';

const OtherIncome = () => {
    const { username } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onDetail = (code) => {
        return window.location.href = `other-income/data/${code}`
    }

    const formIncome = () => {
        return navigate(`/${username}/other-income/form`)
    }

    const [income, setIncome] = useState([]);
    const [pagination, setPagination] = useState([]);
    const getData = async(page) => {
        try {
            const response = await dispatch(getOtherIncome(page)).unwrap().catch((err) => {});
            setIncome(response.data)
            setPagination(response.pagination)
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getData(1);
    }, []);


    const handlePagination = (_, page) => {
        return getData(page);
    }

    return (
        <Layouts>
            <div>
                <div className="d-flex justify-content-between align-items-center">
                    <h1>PENDAPATAN LAINNYA</h1>
                </div>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{lineHeight: '60%'}}>
                                <h3>Data Pendapatan Lainnya</h3>
                                <span>List Data Pendapatan Lainnya</span>
                            </div>
                            <div onClick={formIncome} className="text-center me-2" style={{ cursor: 'pointer' }}>
                                <span className="btn btn-icon btn-orange" style={{ padding: '.4rem .4rem' }}>
                                    <TableView sx={{ width: '1.25rem', height: '1.25rem' }} />
                                </span>
                                <span style={{ fontSize: '12px' }} className="d-block">Form</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="text-center">
                            <h3>
                                DATA PENDAPATAN LAIN PERUMDA ANEKA USAHA <br />
                                KABUPATEN JEPARA <br />
                                TAHUN { new Date().getFullYear() }
                            </h3>
                        </div>
                        <div className="table-responsive">
                            <table className="table align-middle mb-3">
                                <thead>
                                    <tr>
                                        <th className="text-center table-border-start" style={{width: '5%'}}>
                                            <span className="form-control fw-bold">
                                                No
                                            </span>
                                        </th>
                                        <th style={{width: '15%'}}>
                                            <span className="form-control fw-bold">
                                                Kode Pendapatan
                                            </span>
                                        </th>
                                        <th>
                                            <span className="form-control fw-bold">
                                                Tanggal Pendapatan
                                            </span>
                                        </th>
                                        <th>
                                            <span className="form-control fw-bold">
                                                Jenis Pendapatan
                                            </span>
                                        </th>
                                        <th>
                                            <span className="form-control fw-bold">
                                                Nominal
                                            </span>
                                        </th>
                                        <th style={{width: '15%'}} className="text-center table-border-end">
                                            <span className="form-control fw-bold">
                                                Lampiran
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        income.map((data) => (
                                            <tr key={data.no}>
                                                <td className="text-center">{data.no}</td>
                                                <td>{data.code}</td>
                                                <td>
                                                    <Moment format="dddd, DD MMMM YYYY">{data.date}</Moment>
                                                </td>
                                                <td>
                                                    {data.name}
                                                </td>
                                                <td>
                                                    <NumericFormat 
                                                        value={ data.nominal } 
                                                        allowLeadingZeros 
                                                        thousandSeparator="," 
                                                        valueIsNumericString
                                                        prefix="Rp. "
                                                        displayType="text"
                                                        renderText={(value) => <span>{value}</span>}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <a href={ data.file } target="_blank">
                                                        Lihat Lampiran
                                                    </a>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                            {/* pagination */}
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <span>Halaman : { pagination.current_page }</span>
                                </div>
                                {
                                    pagination.pagination ? 
                                    <Paginate count={pagination.total} page={pagination.current_page} onChange={handlePagination} /> : ''
                                }
                                <div>
                                    <span>Total : { pagination.total } List</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layouts>
    )
}

export default OtherIncome
